import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=2f61823f&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f61823f')) {
      api.createRecord('2f61823f', component.options)
    } else {
      api.reload('2f61823f', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=2f61823f&", function () {
      api.rerender('2f61823f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Contact/contact.vue"
export default component.exports